import { DocumentModel } from "@/models/DocumentModel";

import { idGenerator } from "./idGenerator";
import { getStoredSuggestionsDoc, setStoredSuggestionsDoc } from "./suggestionsDocStore";

// TODO: creating new models currently requires having a DocumentModel instance.
// we should be able to create node fragments without using DocumentModel.
export function getSuggestionsDoc(): DocumentModel {
  let suggestionsDoc = getStoredSuggestionsDoc();

  if (!suggestionsDoc) {
    suggestionsDoc = new DocumentModel("suggestions", null);
    suggestionsDoc.idGenerator = idGenerator;
    setStoredSuggestionsDoc(suggestionsDoc);
  }

  return suggestionsDoc;
}

export { disposeSuggestionsDoc } from "./suggestionsDocStore";
